import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const AdUnitBreakdownChart = ({ data }) => {
  if (!data || !data.length) {
    return null;
  }

  // Aggregate data by ad unit
  const adUnitBreakdown = data.reduce((acc, row) => {
    const adUnit = row.ad_unit || 'Unknown';
    if (!acc[adUnit]) {
      acc[adUnit] = {
        ad_unit: adUnit,
        impressions: 0,
        clicks: 0,
        ctr: 0,
        fill_rate: 0,
        completion_rate: 0,
      };
    }
    acc[adUnit].impressions += parseFloat(row.impressions || 0);
    acc[adUnit].clicks += parseFloat(row.clicks || 0);
    acc[adUnit].fill_rate += parseFloat(row.fill_rate || 0);
    acc[adUnit].completion_rate += parseFloat(row.completion_rate || 0);
    return acc;
  }, {});

  const chartData = Object.values(adUnitBreakdown)
    .map(item => ({
      ...item,
      ctr: item.impressions > 0 ? (item.clicks / item.impressions) * 100 : 0,
      fill_rate: item.fill_rate / Object.keys(adUnitBreakdown).length,
      completion_rate: item.completion_rate / Object.keys(adUnitBreakdown).length,
    }))
    .sort((a, b) => b.impressions - a.impressions)
    .slice(0, 5);

  if (chartData.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Performance by Ad Unit</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="ad_unit" stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 12 }} />
            <YAxis stroke="#6b7280" tick={{ fill: '#6b7280', fontSize: 12 }} tickFormatter={(value) => value >= 1000 ? `${(value / 1000).toFixed(1)}K` : value.toString()} />
            <Tooltip 
              contentStyle={{ backgroundColor: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: '8px' }}
            />
            <Legend />
            <Bar dataKey="impressions" fill="#3b82f6" name="Impressions" />
            <Bar dataKey="clicks" fill="#10b981" name="Clicks" />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};

export default AdUnitBreakdownChart;
